import { render, staticRenderFns } from "./KETUnterweisung.vue?vue&type=template&id=65cd2646&"
import script from "./KETUnterweisung.vue?vue&type=script&lang=js&"
export * from "./KETUnterweisung.vue?vue&type=script&lang=js&"
import style0 from "./KETUnterweisung.vue?vue&type=style&index=0&id=65cd2646&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports